import { UserActionTypes, ApiKey, UserState } from './types';
import { Reducer } from 'redux';

const initialState: UserState = {
  loading: false,
  // Temporary block - need to delete after Helix enabled
  remedyForceClient: undefined,
  // Temporary block
  apiKeys: null
};

const reducer: Reducer<UserState> = (state = initialState, action: any) => {
  switch (action.type) {
    case UserActionTypes.FETCH_USER_START: {
      return {
        ...initialState,
        loading: true
      };
    }
    case UserActionTypes.FETCH_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        updatingUser: undefined,
        user: action.payload
      };
    }
    case UserActionTypes.FETCH_USER_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case UserActionTypes.SIGN_OUT: {
      return initialState;
    }

    case UserActionTypes.FETCH_USER_SEARCH_START: {
      return {
        ...initialState,
        loading: true
      };
    }
    case UserActionTypes.FETCH_USER_SEARCH_SUCCESS: {
      return {
        ...state,
        loading: false,
        users: action.payload
      };
    }
    case UserActionTypes.FETCH_USER_SEARCH_FAILURE: {
      const cleanState: UserState = {
        loading: false,
        apiKeys: null,
        profileUpdatingFlag: undefined,
        contactSupportFlag: undefined
      };
      return {
        ...cleanState,
        error: action.payload
      };
    }

    case UserActionTypes.ADD_APIKEYS_START: {
      return {
        ...state,
        loading: true
      };
    }
    case UserActionTypes.ADD_APIKEYS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case UserActionTypes.DELETE_APIKEYS_START: {
      return {
        ...state,
        loading: true
      };
    }
    case UserActionTypes.DELETE_APIKEYS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case UserActionTypes.FETCH_APIKEYS_START: {
      return {
        ...state,
        loading: true
      };
    }
    case UserActionTypes.FETCH_APIKEYS_SUCCESS: {
      return {
        ...state,
        loading: false,
        apiKeys: action.payload.ApiKeys.map(
          ({ clientId, lastUsedAt, id, createdAt }: ApiKey) => ({
            clientId,
            lastUsedAt,
            id,
            createdAt
          })
        )
      };
    }
    case UserActionTypes.FETCH_APIKEYS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case UserActionTypes.PROFILE_UPDATING_FLAG: {
      return {
        ...state,
        contactSupportFlag: undefined,
        profileUpdatingFlag: !state.profileUpdatingFlag
      };
    }
    case UserActionTypes.CONTACT_SUPPORT_FLAG: {
      return {
        ...state,
        profileUpdatingFlag: undefined,
        contactSupportFlag: !state.contactSupportFlag
      };
    }
    case UserActionTypes.UPDATE_USER_START: {
      return {
        ...state,
        updatingUser: true,
        loading: true
      };
    }
    case UserActionTypes.UPDATE_USER_SUCCESS: {
      return {
        ...state,
        updatingUser: false,
        loading: false,
        users: action.payload
      };
    }
    case UserActionTypes.UPDATE_USER_DONE: {
      return {
        ...state,
        updatingUser: undefined
      };
    }
    case UserActionTypes.CONTACT_SUPPORT_START: {
      return {
        ...state,
        supportReqSubmitting: true,
        supportRes: action.payload,
        contactSupportError: false
      };
    }
    case UserActionTypes.CONTACT_SUPPORT_SUCCESS: {
      return {
        ...state,
        supportReqSubmitting: false,
        contactSupportFlag: undefined,
        supportRes: action.payload,
        contactSupportError: false
      };
    }
    case UserActionTypes.CONTACT_SUPPORT_FAILURE: {
      return {
        ...state,
        supportReqSubmitting: false,
        contactSupportFlag: undefined,
        error: action.payload,
        contactSupportError: true
      };
    }
    case UserActionTypes.CONTACT_SUPPORT_CLEAR: {
      return {
        ...state,
        supportReqSubmitting: false,
        contactSupportFlag: undefined,
        contactSupportError: false,
        supportRes: undefined
      };
    }
    case UserActionTypes.GET_ADDRESS_SEARCH_SUGGESTION_SUCCESS:
      return {
        ...state,
        addressSearchSuggestion: action.payload
      };
    case UserActionTypes.GET_ADDRESS_SEARCH_SUGGESTION_FAILURE:
      return {
        ...state,
        addressSearchSuggestion: action.payload
      };
    case UserActionTypes.CLEAR_ADDRESS_SEARCH_SUGGESTION:
      return {
        ...state,
        addressSearchSuggestion: undefined
      };
    case UserActionTypes.SHOW_NOTIFICATION_OPTIONS_MODAL: {
      return {
        ...state,
        showNotificationOptionsModal: action.payload
      };
    }
    // Temporary block - need to delete after Helix enabled
    case UserActionTypes.FETCH_REMEDY_FORCE_USER_SUCCESS:
      return {
        ...state,
        remedyForceClient: action.payload
      };
    case UserActionTypes.FETCH_REMEDY_FORCE_USER_FAILURE:
      return {
        ...state,
        remedyForceClient: false,
        error: action.payload
      };
    // Temporary block
    default:
      return state;
  }
};

export { reducer as UserReducer };
